@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';
@import (reference) '../settings-page.module.less';

.refund-assist-page-content {
  background-color: @seller-settings--page--background-color;
  padding: @settings-page-content-padding;
  overflow-y: auto;
  height: 100%;
}

.refund-assist-section {
  max-width: 664px;
}

.header-section {
  gap: @space-16;
  margin-top: @space-16;
}

.learnMoreLink {
  display: flex;
  align-items: center;
}

.learnMoreIcon {
  margin-left: @space-4;
  height: 12px;
  width: 12px;
}

.refund-assist-toggle {
  line-height: @space-24;
  margin-bottom: @space-0;

  .refund-assist-toggle-label {
    // different from TextType.Description which is 400
    font-weight: 700;
  }
}

.refund-assist-card {
  margin-top: @space-24;
  padding: @space-16 @space-16;
  border-radius: @space-8;
  border: 1px solid var(--gray-E4E5E7);
  background: @seller-setting--page--section-container--background-color;
  gap: @space-12;
  max-width: 1009px;
}

.disclaimer-content {
  gap: @space-12;
  padding-top: @space-32;
}

.disclaimer-toggle-button {
  display: flex;
  align-items: center;
  color: var(--blue-1D5AD8);

  .disclaimer-toggle-text {
    cursor: pointer;
  }

  .disclaimer-arrow {
    margin-left: @space-4;
    height: 16px;
    width: 16px;
  }
}

.usps-disclaimer-card {
  margin-top: @space-12;
  padding: @space-16;
  border-radius: @space-8;
  border: 1px solid var(--gray-E4E5E7);
  background: var(--gray-F9FAFB);
  gap: @space-8;

  // add padding to each child
  > * {
    padding-top: @space-8;
  }
}

.disable-refund-assist-modal-bullet-points {
  padding: @space-12 @space-12 @space-24;
}
